import React, { useEffect, useState } from 'react';
import {
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Step,
  StepLabel,
  Stepper,
  Typography
} from '@mui/material';
import { useOrderManagementStore } from '../../../zustandStore/store.ordermgt';

const OrderManagementHeader: React.FC = () => {

  return (
    <>
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item>
          <Typography variant="h3" component="h3" gutterBottom>
            Order Management
          </Typography>
          <Typography variant="subtitle2">
            Generate an order for a customer, or manage existing orders.
          </Typography>
        </Grid>

      </Grid>
    </>
  );
};

export default OrderManagementHeader;
